/* */ 
var global = require('./$.global'),
    SHARED = '__core-js_shared__',
    store = global[SHARED] || (global[SHARED] = {});
module.exports = function(key) {
  return store[key] || (store[key] = {});
};
